import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { StorageAnalitical } from '../../../components/Grossharvestofproducts/Storage';

const StorageAnaliticalPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Хранилища</title>
            </Helmet>
            <StorageAnalitical/>
        
        </>
    );
};

export default StorageAnaliticalPage
